import { useTheme } from '@/contexts/ThemeContext';
import { Button } from '@/components/ui/button';
import { Sun, Moon, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import GlobeLogo from '@/components/shared/GlobeLogo';

export default function Navbar({ onToggleSidebar }) {
  const { theme, toggleTheme } = useTheme();
  return <header className="cg-navbar" data-testid="navbar">
    <div className="cg-navbar-inner"><Link to="/" className="cg-brand" aria-label="CalcGlobe home"><GlobeLogo size={34} /><span>CalcGlobe</span></Link>
      <nav aria-label="Main navigation" className="cg-top-links"><Link to="/sitemap/">Calculators</Link><button onClick={onToggleSidebar}>Categories</button><Link to="/about/">About</Link></nav>
      <div className="flex items-center gap-2"><Button variant="ghost" size="icon" onClick={toggleTheme} data-testid="theme-toggle-btn" aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>{theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}</Button><Button variant="outline" size="icon" onClick={onToggleSidebar} data-testid="mobile-menu-btn" aria-label="Open calculator navigation"><Menu size={19} /></Button></div>
    </div>
  </header>;
}
